import { EMMA_KPIS, EMMA_LEGACY_KPIS } from './emma-ng.constant';

export const ORGANIC_CAMPAIGN = 'Organic';
export const ORGANIC_CHANNEL = 'organic';
export const ORGANIC_CHANNEL_NAME = 'Organic';
export const DEFAULT_COUNTRY = 'Unlocated';
export const enum ORGANIC_SOURCE_TYPE {
  IOS = 'ios',
  ANDROID = 'android',
  HUAWEI = 'huawei',
  UNKNOWN = 'unknown',
}

export const ORGANIC_SOURCE_NAMES = {
  [ORGANIC_SOURCE_TYPE.IOS]: 'App Store (iOS)',
  [ORGANIC_SOURCE_TYPE.ANDROID]: 'Google Play (Android)',
  [ORGANIC_SOURCE_TYPE.HUAWEI]: 'App Gallery (Android)',
  [ORGANIC_SOURCE_TYPE.UNKNOWN]: 'Unknown Store (Unknown OS)',
};

export const enum EMMA_URL_PARAMS {
  ENTW = 'entw',
  ECID = 'ecid',
  RT = 'rt',
  AW = 'aw',
}

export const DEFAULT_APP_SCHEME = 'scheme://';

export const enum APPTRACKER_CHANNELS {
  FACEBOOK = 'facebook',
  FACEBOOK_INSTAGRAM = 'instagram',
  FACEBOOK_AUDIENCE_NETWORK = 'audiencenetwork',
  FACEBOOK_MESSENGER = 'messenger',
  GOOGLE_ADS = 'adwords',
  APPLE_SEARCH_ADS = 'applesearchads',
  PETAL_ADS = 'petalads',
  REDDIT = 'reddit',
  SKADNETWORK = 'skadnetwork',
  SNAPCHAT = 'snapchat',
  TWITTER = 'twitter',
  TIKTOK = 'tiktok',
  TIKTOK_SAN = 'tiktoksan',
}

export enum SAN_USER_CHANNEL {
  GOOGLE_ACI = 'Google Ads - ACI',
  GOOGLE_ACE = 'Google Ads - ACE',
  GOOGLE_UAC = 'Google Ads - UAC',
  GOOGLE_UACE = 'Google Ads - UACE',
  GOOGLE_SEARCH = 'Google Ads - Search',
  GOOGLE_DISPLAY = 'Google Ads - Display',
  GOOGLE_VIDEO = 'Google Ads - Video',
  GOOGLE_GENERIC = 'Google Ads - Generic',
  TWITTER_X = 'X (Twitter)',
  TIKTOK = 'TikTok',
  SNAPCHAT = 'Snapchat',
  APPLE_SEARCH_ADS = 'Apple Search Ads',
  MICROSOFT_ADS = 'Microsoft Ads',
  FACEBOOK = 'Meta',
  PETAL_ADS = 'Petal Ads - Generic',
}

export enum APPTRACKER_GROUP_VIEW {
  CAMPAIGNS = 'campaigns',
  CHANNELS = 'channels',
}

export const HIDDEN_KPIS_IN_APPTRACKER: string[] = [
  EMMA_LEGACY_KPIS.CPA,
  EMMA_LEGACY_KPIS.CPI,
  EMMA_LEGACY_KPIS.CPC,
  EMMA_LEGACY_KPIS.CPS,
  EMMA_LEGACY_KPIS.CPL,
  EMMA_LEGACY_KPIS.CPB,
  EMMA_LEGACY_KPIS.DAILY_BUYERS,
  EMMA_LEGACY_KPIS.BUYERS,
  EMMA_LEGACY_KPIS.SALES,
  EMMA_KPIS.REVENUE,
  EMMA_KPIS.ROI,
];

export const NO_CHANNEL_VALUE = '(empty)';
